<template>
  <div class="confirm" v-loading="loading">
    <div class="container">
      <div class="common-header">
        <es-breadcrumb>
          <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
          <es-breadcrumb-item>{{ $t('确认订单信息') }}</es-breadcrumb-item>
        </es-breadcrumb>
      </div>
      <divided />
      <div class="body">
        <div class="confirm-time" v-show="productType != 2 && !hideContinuedType">
          <span style="width: 100px; margin-right: 40px; color: #1a1a1aff">{{ $t('订单生效时间:') }}</span>
          <es-radio v-model="isContinuedValidityTerm" :label="2">
            <es-date-picker v-model="useTime" type="date" unlink-panels :picker-options="pickerOptions"
              value-format="timestamp" style="margin-right: 10px" :disabled="disableTimeChange"></es-date-picker>
            <span style="font-size: 12px; color: #999" v-if="!disableTimeChange">
              {{ $t('您可以设置订单开始生效时间，即以此时间开始方可使用相关服务') }}
            </span>
          </es-radio>
        </div>
        <div class="confirm-time" style="padding-left: 140px" v-show="showAutoBuy">
          <es-radio v-model="isContinuedValidityTerm" :label="1" style="font-size: 14px">
            {{ $t('原订单结束后自动延续') }}
            <br />
          </es-radio>
          <span style="margin-left: 32px; font-size: 12px; color: #999">
            {{ $t('您可以设置订单开始时间为延续当前使用订单的结束之时') }}
          </span>
        </div>
        <es-table class="confirm-table" :data="menuData">
          <template slot="empty">
            <es-empty style="margin: 25px; color: #999; line-height: 40px" :description="$t(`暂无更多数据`)"
              image="data:image/png;base64,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"></es-empty>
          </template>
          <es-table-column prop="commodityName" :label="$t(`产品名称`)" width="220"></es-table-column>
          <es-table-column prop="menu" :label="$t(`套餐名称`)" width="200">
            <template slot-scope="scope">
              <span v-if="menuData[0].saleType === 1">
                {{ menuData[0].packageName || menuData[0].packages[0].packageName }}
              </span>
              <span v-else-if="menuData[0].saleType === 3">
                {{ menuData[0].packageName || menuData[0].licenses[0].licenseName }}
              </span>
              <span v-else>— —</span>
              <es-tooltip class="item" effect="light" v-if="tyingInfo.isTying" placement="bottom-end">
                <div class="gift-icon"></div>
                <div slot="content">
                  {{ $t('套餐附带：') }}
                  <div style="margin: 5px" v-for="item in tyingInfo.tyingInfoList" :key="item.remark">
                    {{ item.remark }}
                  </div>
                </div>
              </es-tooltip>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`购买个数`)" v-if="saleType === 1 || saleType === 3" width="180">
            <template slot-scope="scope">
              <div>
                X
                <es-input-number v-model="num" :disabled="banNumContral" controls-position="right"
                  @change="handleChange" :min="1" :max="max"></es-input-number>
              </div>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`产品规格`)" width="180">
            <template slot-scope="scope">
              <es-input v-if="scope.row.saleType === 2" :value="count" :disabled="banNumContral" @input="handleInput"
                :min="1" size="mini" style="width: 100px" @blur="getExel"></es-input>
              <span v-if="scope.row.saleType === 2">{{ $t('元') }}</span>
              <span v-if="scope.row.saleType === 1 || scope.row.saleType === 3">
                {{ $t('总数量：') }}{{ totalNum * num }} {{ scope.row.units }}
              </span>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`标准价格（元）`)">
            <template slot-scope="scope">
              <span>{{ (scope.row.standardPrice * num).toFixed(2) }}</span>
            </template>
          </es-table-column>
          <es-table-column prop="effective" :label="$t(`有效期`)"></es-table-column>
          <es-table-column :label="$t(`优惠方式`)">
            <template slot-scope="scope">
              <span>{{ returnShowSaleOff(scope.row.saleOff) }}</span>
            </template>
          </es-table-column>
          <es-table-column prop="totalPrice" :label="$t(`合计价格（元）`)">
            <template slot-scope="scope">
              <span>{{ returnSaleMoney(scope.row.totalPrice).toFixed(2) }}</span>
            </template>
          </es-table-column>
        </es-table>
        <!-- 收货人信息 -->
        <Address @getVal="getVal" v-if="isDeliver"></Address>
        <div class="confirm-title" v-if="returnSaleMoney(billForm.menu) >= 200">
          <span class="confirm-title-text"></span>
          <div>
            <es-radio v-model="invoice" @change="needInvoice" :label="1">{{ $t('不开发票') }}</es-radio>
            <es-radio v-model="invoice" @change="needInvoice" :label="2">{{ $t('开发票') }}</es-radio>
          </div>
        </div>
        <Invoice ref="invoice" v-if="invoice === 2 && returnSaleMoney(billForm.menu) >= 200"
          :money="returnSaleMoney(billForm.menu)" @getInfo="getInvoiceInfo" :title="$t(`确认发票信息`)"
          :showAddress="showAddress">
          <div class="infoBody">
            <es-form :model="form" :rules="rules" ref="ruleForm" label-width="110px" class="ruleForm"
              label-position="left">
              <div class="left">
                <es-form-item :label="$t(`发票抬头`)">
                  <span class="content">{{ userInfo.name }}</span>
                </es-form-item>
                <es-form-item :label="$t(`纳税人识别号`)" prop="identifyNumber" v-if="isOrg">
                  <es-input v-model="form.identifyNumber" :placeholder="$t(`请输入纳税人识别号`)"
                    style="width: 280px"></es-input>
                </es-form-item>
                <es-form-item :label="$t(`发票类型`)">
                  <es-select v-model="form.invoiceType" :placeholder="$t(`请选择发票类型`)" v-if="isOrg"
                    @change="changeInvoice">
                    <es-option :label="$t(`增值税普通发票`)" :value="1"></es-option>
                    <es-option :label="$t(`增值税专用发票`)" :value="2"></es-option>
                  </es-select>
                  <span v-else class="content">{{ $t('增值税普通发票') }}</span>
                </es-form-item>
                <es-form-item :label="$t(`发票形式`)">
                  <es-radio-group v-model="form.invoiceForm">
                    <es-radio :label="1" v-if="form.invoiceForm === 1">{{ $t('电子发票') }}</es-radio>
                    <es-radio :label="2" v-if="form.invoiceForm === 2">{{ $t('纸质发票') }}</es-radio>
                  </es-radio-group>
                </es-form-item>
              </div>
              <div class="right">
                <div class="inline-block">
                  <es-form-item :label="$t(`开户银行`)" prop="bank">
                    <es-select v-model="form.bank" filterable clearable remote :placeholder="$t(`请选择开户银行`)"
                      :remote-method="remoteMethod" :loading="searchLoading" style="width: 133px; margin-right: 20px">
                      <es-option v-for="item in bankList" :key="item.id" :label="item.subBankName"
                        :value="item.subBankName"></es-option>
                    </es-select>
                  </es-form-item>
                  <es-form-item :label="$t(`银行账号`)" prop="bankAccount">
                    <es-input v-model="form.bankAccount" :placeholder="$t(`请输入银行账号`)" maxlength="30"
                      @input="changeBankAccount()"></es-input>
                  </es-form-item>
                </div>
                <es-form-item :label="$t(`开票地址`)" prop="invoiceAddress">
                  <es-input v-model="form.invoiceAddress" :placeholder="$t(`请输入开票地址`)" style="width: 480px"
                    maxlength="128"></es-input>
                </es-form-item>
                <es-form-item :label="$t(`开票电话`)" prop="invoiceTelephone">
                  <es-input v-model="form.invoiceTelephone"
                    :placeholder="$t(`开票电话，例:18899990000 或 0571-12345678-001 或 400-888-8888`)" style="width: 480px"
                    maxlength="128"></es-input>
                </es-form-item>
                <es-form-item v-if="form.invoiceType === 2 && form.invoiceForm === 1" :label="$t(`接收邮箱`)"
                  prop="invoiceEmail">
                  <es-input v-model="form.invoiceEmail" :placeholder="$t(`电子票开具后，我们会直接通过邮件向您发送对应票据`)"
                    style="width: 480px" maxlength="128"></es-input>
                </es-form-item>
              </div>
            </es-form>
          </div>
        </Invoice>
        <div class="confirm-bill">
          <es-form class="confirm-bill-form" label-position="right" label-width="120px" :model="billForm">
            <es-form-item class="confirm-bill-form-item" :label="$t(`购买方：`)">
              <span>{{ isOrg ? $t('企业') : $t('个人') }} ({{ userInfo.name }})</span>
            </es-form-item>
            <es-form-item class="confirm-bill-form-item" :label="$t(`商品标准价格：`)">
              <span>{{ numberCal.mul(billForm.menu, num.toFixed(2)) }}{{ $t('元') }}</span>
            </es-form-item>
            <es-form-item v-if="discounted !== 0" class="confirm-bill-form-item" :label="$t(`已优惠金额：`)">
              <span>-{{ discounted }}{{ $t('元') }}</span>
            </es-form-item>
            <es-form-item v-show="invoice === 2" class="confirm-bill-form-item" :label="$t(`发票快递费：`)">
              <span>{{ billForm.express.toFixed(2) }}{{ $t('元') }}</span>
            </es-form-item>
            <es-form-item v-if="promotionDisplay" class="confirm-bill-form-item" :label="$t(`优惠券：`)">
              <span class="change-ticket" v-if="!isChangeStatus" @click="checkCoupons = true">
                {{ $t('有可用优惠券') }}
                <i class="el-icon-circle-plus"></i>
              </span>
              <div v-else class="change-ticket">
                <span @click="showCoupons()">{{ $t('已输入优惠券') }}</span>
                <i class="el-icon-remove" @click="clearCoupons()"></i>
              </div>
            </es-form-item>
            <es-form-item class="confirm-bill-form-item" label-width="120px" :label="$t(`总金额：`)">
              <span style="font-size: 20px; color: #e74333">
                {{ (returnSaleMoney(billForm.menu) + billForm.express).toFixed(2) }}{{ $t('元') }}
              </span>
            </es-form-item>
          </es-form>
          <div class="confirm-agree">
            <es-checkbox v-model="checked">{{ $t('我已阅读，同意此协议') }}</es-checkbox>
            <span class="confirm-agree-btn" @click="viewCert">{{ $t('点此查看协议') }}</span>
          </div>
          <div :class="['confirm-bill-confirm', { disabled: !checked || paying }]" @click="createOrder">
            {{ $t('提交订单') }}
          </div>
        </div>
      </div>
    </div>
    <es-dialog :title="$t(`使用优惠券`)" :visible.sync="checkCoupons" width="500px">
      <div class="content">
        <p class="content-left">{{ $t('优惠券编号') }}</p>
        <es-input class="content-right" v-model="couponsNumber" :placeholder="$t(`请输入优惠券编号`)"></es-input>
      </div>
      <p v-if="isChangeStatus" class="tips">{{ $t('再次确认后将替换之前的优惠') }}</p>
      <span slot="footer">
        <es-button type="primary" @click="checkCouponsNumber()" :loading="btnLoading">{{ $t('确定') }}</es-button>
        <es-button variant="outline" @click="checkCoupons = false">{{ $t('取消') }}</es-button>
      </span>
    </es-dialog>
  </div>
</template>
<script>
import { $t } from '@/locales'
import { base64Decode, getTimingData, numberCal } from '@/util'
import { orderSourceMap } from '@esign/esign-client-jssdk'
import tsignDataTrack from '@tsign/tsigndata-sdk-js'
import { mapState } from 'vuex'
import Address from '../../components/address'
import divided from '../../components/divided'
import Invoice from '../../components/invoice'
export default {
  components: {
    Invoice,
    divided,
    Address
  },
  data () {
    const validateIdentifyNumber = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error($t('请输入纳税人识别号')))
      } else if (/^[A-Za-z0-9]+$/.test(value)) {
        callback()
      } else {
        callback(new Error($t('请输入数字或字母的组合')))
      }
    }

    return {
      numberCal,
      banNumContral: false,
      max: this.$route.query.max ? parseInt(this.$route.query.max) : 99999,
      addressInfo: {
        receiverAddress: '',
        receiverName: '',
        receiverPhone: ''
      },
      sourceChannel: Number(sessionStorage.getItem('source_channel')) || 0,
      isDeliver: 0,
      choosedPackage: {},
      num: this.$route.query.num || 1,
      saleMark: '', // 售卖对象
      productType: '',
      saleType: '',
      exeTotalNum: '',
      extPrice: '',
      commodityNo: '',
      billingProductId: '',
      pdfLoading: true,
      showAddress: true,
      isContinuedValidityTerm: 2,
      hideContinuedType: false,
      haveOrders: false,
      lastEndTime: '',
      used: 0,
      paying: false,
      useTime: '',
      menuData: [],
      count: 0,
      commodityName: '',
      commoditieData: [],
      checked: false,
      dialogVisible: false,
      loading: false,
      protocol: '',
      invoice: 1,
      invoiceData: {},
      totalNum: '',
      packages: [],
      billForm: {
        menu: 0,
        express: 0,
        total: 0
      },
      form: {
        invoiceAddress: '',
        invoiceForm: 1,
        invoiceEmail: '',
        invoiceTelephone: '',
        bank: '',
        invoiceType: '',
        identifyNumber: '',
        bankAccount: ''
      },
      invoiceTypeList: [
        {
          value: 1,
          label: $t('增值税普通发票')
        },
        {
          value: 2,
          label: $t('增值税专用发票')
        }
      ],
      invoiceType: {
        // 普通发票
        normalInvoiceForm: 'ELECTRON',
        // 特殊发票
        specialInvoiceForm: 'ELECTRON',
      },

      bankList: [],
      bank: '',
      rules: {
        identifyNumber: [{ validator: validateIdentifyNumber, trigger: 'blur' }],
        bank: [{ required: true, message: $t('请选择开户银行'), trigger: 'change' }],
        bankAccount: [{ required: true, message: $t('请输入银行账号'), trigger: 'blur' }],
        invoiceAddress: [{ required: true, message: $t('请输入开票地址'), trigger: 'blur' }],
        invoiceTelephone: [
          { required: true, message: $t('请填写开票电话'), trigger: 'blur' },
          {
            type: 'string',
            trigger: 'blur',
            message: $t('请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888'),
            pattern: /^((?:(?:(\+)|(00))86)?1\d{10})$|^([48]00-?\d{3}-?\d{4})$|^((?:0\d{2,3}-)?(\d{5,8}(-\d{3,5})?))$/
          }
        ],
        invoiceEmail: [
          { required: true, message: $t('请输入接收邮箱'), trigger: 'blur' },
          {
            type: 'email',
            message: $t('请正确填写接收邮箱'),
            trigger: ['blur', 'change']
          }
        ]
      },
      // 访问pdf定时器
      getPdfTimer: null,
      saleOff: '',
      discountType: '',
      discountAmount: '',
      discounted: 0,
      promotionDisplay: false, // 优惠方式
      discountPrice: 0,
      checkCoupons: false,
      isChangeStatus: false, // 优惠码调整状态
      couponsNumber: '',
      realCouponsNumber: '',
      btnLoading: false, // 使用优惠券的loading
      activeNo: null,
      searchLoading: false,
      disableTimeChange: parseInt(this.$route.query.source_channel) === 9,
      getInTime: Date.now(),
      firstReqTime: null,
      lastResTime: null,
      tyingInfo: {}, // 搭售信息
      companyCode: '', // 公司主体 esign-天谷；KingGridJX-江西金格；KingGridGZ-广州金格；KingGridBJ-北京金格；HealthSP-易签宝；
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
      tsignData: state => state.tsignData
    }),
    /** 隐藏原订单结束后自动延续
     * hideAutoContinue 上游传递 1 - 隐藏 0 - 展示
     */
    showAutoBuy () {
      const { hideAutoContinue } = this.$route.query
      const hide = Number(hideAutoContinue) || 0

      return this.lastEndTime && this.haveOrders && hide !== 1
    },
    pickerOptions () {
      const dayTimeStamp = 1000 * 60 * 60 * 24

      return {
        disabledDate (time) {
          return time.getTime() < Date.now() - dayTimeStamp
        }
      }
    }
  },
  mounted () {
    // 通过传参控制是否展示订单生效时间
    this.hideContinuedType = Number(this.$route.query.continuedType) === 1
    this.isContinuedValidityTerm = this.hideContinuedType ? 1 : 2
    if (this.$route.query.tsign_source_type === 'DITCH' && this.$route.query.ditchID) {
      this.getPromoInfo(this.$route.query.ditchID)
    } else {
      this.init()
    }
  },
  methods: {
    // http://wiki.timevale.cn:8081/pages/viewpage.action?pageId=206901736
    reportSourceChannel () {
      const personOid = localStorage.getItem('ouid')
      const personGid = localStorage.getItem('guid')
      const data = {
        commodity_number: (this.totalNum || this.exeTotalNum) * this.num,
        commodity_name: this.commodityName || 'pcerror',
        commodity_id: this.$route.query.commodityId,
        user_type: this.isOrg ? '企业' : '个人',
        oid: this.isOrg ? this.userInfo.orgId : personOid,
        gid: this.isOrg ? this.userInfo.gid : personGid,
        pay_amount: (this.returnSaleMoney(this.billForm.menu) + this.billForm.express).toFixed(2),
        geren_oid: personOid,
        geren_gid: personGid,
        order_source: orderSourceMap[this.sourceChannel] || 'other',
        order_id: '-'
      }
      tsignDataTrack.track('to_creat_order', data)
    },
    // 上报神策埋点
    reportShenCeData (lastResTime) {
      try {
        let dataObj = getTimingData($t('我的订单-下单'))
        let reqDataObj = {}
        if (this.lastResTime) {
          // 代表一定触发了接口请求且有返回
          reqDataObj = {
            businessData_load_time: lastResTime - this.firstReqTime,
            time_consume: lastResTime - performance.getEntriesByType("navigation")[0].fetchStart
          }
          dataObj = { ...dataObj, ...reqDataObj }
        }
        tsignDataTrack.track('front_init_time_consume', dataObj)
      } catch (error) {
        console.log(error)
      }
    },
    // 清除已输入的优惠券
    clearCoupons () {
      this.$confirm($t('是否删除当前优惠券信息？'))
        .then(_ => {
          this.realCouponsNumber = this.couponsNumber = ''
          this.getExecRule(this.count, this.count)
        })
        .catch(_ => { })
    },

    // 银行账户校验
    changeBankAccount () {
      this.form.bankAccount = this.form.bankAccount.replace(/[^0-9]/g, '')
    },

    // 再次输入优惠券
    showCoupons () {
      this.checkCoupons = true
      this.couponsNumber = this.realCouponsNumber
    },
    // 使用优惠券
    checkCouponsNumber () {
      this.btnLoading = true
      this.getExecRule(this.count, this.count)
    },
    // 获取优惠
    getPromoInfo (channelGid) {
      this.firstReqTime = Date.now()
      this.$ajax(this.$url.getPromo(), { channelGid }).then(res => {
        this.promotionDisplay = res.data
        this.lastResTime = Date.now()
        this.init()
      })
    },
    getVal (val) {
      this.addressInfo.receiverAddress = val.receiverAddress
      this.addressInfo.receiverName = val.receiverName
      this.addressInfo.receiverPhone = val.receiverPhone
    },
    handleClose () {
      this.getPdfTimer && clearInterval(this.getPdfTimer)
    },
    // 获取发票银行账号
    getBankInfoBySubName (subBankName) {
      const self = this
      this.$ajax(this.$url.getBankInfoBySubName(), {
        subBankName
      })
        .then(res => {
          self.bankList = res.data.list
          self.searchLoading = false
        })
        .catch(() => (self.searchLoading = false))
    },
    remoteMethod (query) {
      if (query && query.trim()) {
        this.searchLoading = true
        this.getBankInfoBySubName(query.trim())
      }
    },
    handleChange () {
      this.$nextTick(() => {
        this.num = parseInt(this.num)
        this.invoice = 1
        this.billForm.express = 0
        this.getExecRule(this.choosedPackage.totalNum, this.choosedPackage.price)
      })
    },
    async init () {
      this.firstReqTime = Date.now()
      this.form.invoiceType = 1
      this.useTime = +new Date()
      this.loading = true
      if (this.$route.query.banNumContral && this.$route.query.banNumContral !== 'undefined') {
        this.banNumContral = true
      }

      if (this.$route.query.commodityId) {
        const res = await this.$ajax(this.$url.getCommodities(), {
          id: this.$route.query.commodityId,
          showcaseNos: this.$route.query.showcaseNos ? [this.$route.query.showcaseNos] : []
        })
        this.$ajax(this.$url.getTying(), {
          saleInfoId: this.$route.query.menuId
        }).then(tying => {
          this.tyingInfo = tying.data
        })
        this.lastResTime = Date.now()
        this.companyCode = res.data.companyCode
        this.commodityNo = res.data.commodityNo
        this.isDeliver = res.data.isDeliver
        this.saleMark = res.data.saleMark
        this.commodityName = res.data.commodityName
        this.productType = res.data.billingProduct.productType
        this.saleType = res.data.saleType
        this.billingProductId = res.data.billingProductId
        if (this.saleType === 1 || this.saleType === 3) {
          this.menuData = [{ saleOff: $t('无优惠'), menu: '', ...res.data }]
          this.packages = this.saleType === 1 ? this.menuData[0].packages : this.menuData[0].licenses

          let id = ''
          if (this.$route.query.menuId) {
            id = Number(this.$route.query.menuId)
          } else if (this.saleType === 1) {
            id = this.menuData[0].packages[0].id
          } else if (this.saleType === 3) {
            id = this.menuData[0].licenses[0].id
          }
          this.chooseMenu(id, this.$route.query.amount)
          this.menuData[0].menu = id
        } else if (this.saleType === 2) {
          this.count = this.$route.query.amount || 1
          this.menuData = [
            {
              saleOff: $t('无优惠'),
              effective: $t('无限'),
              totalPrice: 1,
              menu: '',
              ...res.data
            },
          ]

          this.getBillMoney()
          this.getExecRule(this.count, this.count)
        }
        this.loading = false
        this.isConsiderUsageAmount = res.data.billingProduct.isConsiderUsageAmount
        const data = {
          saleSchemaId: res.data.saleSchemeId,
          productId: res.data.billingProduct.id
        }
        const getHistoryRes = await this.$ajax(this.$url.getHistoryUsed(), data)
        this.haveOrders = getHistoryRes.data.haveOrders
        this.lastEndTime = getHistoryRes.data.lastEndTime
        this.used = getHistoryRes.data.used
        if (this.isOrg) {
          this.$ajax(this.$url.orgGetInfo()).then(info => {
            this.form.identifyNumber =
              info.data.prop.credentials.usccCode ||
              info.data.prop.credentials.taxCode ||
              info.data.prop.credentials.regCode ||
              info.data.prop.credentials.orgCode
          })
        }
        this.reportSourceChannel()
      } else {
        this.$message.error($t('缺少参数'))
      }
      this.reportShenCeData(this.lastResTime)
    },
    viewCert () {
      window.open('https://asset.esign.cn/template/agreement.html', '_blank')
    },
    getExel () {
      this.getExecRule(this.count, this.count)
    },
    chooseMenu (val, num) {
      this.num = num || 1
      const choosedPackage = this.packages.filter(item => item.id === val)[0]
      this.totalNum = choosedPackage.totalNum
      let unit = ''
      if (choosedPackage.effectiveIsUnlimited === 0) {
        if (choosedPackage.effectiveUnit === 'DAY') {
          unit = $t('{slot1}天', { slot1: choosedPackage.effectiveDate })
        } else if (choosedPackage.effectiveUnit === 'YEAR') {
          unit = $t('{slot1}年', { slot1: choosedPackage.effectiveDate })
        } else if (choosedPackage.effectiveUnit === 'MONTH') {
          unit = $t('{slot1}月', { slot1: choosedPackage.effectiveDate })
        }
      } else if (choosedPackage.effectiveIsUnlimited === 1) {
        unit = $t('无限')
      }
      this.menuData[0].standardPrice = choosedPackage.price
      this.menuData[0].effective = unit || '--'
      this.menuData[0].totalPrice = choosedPackage.price
      this.menuData[0].packageName = choosedPackage.packageName || choosedPackage.licenseName
      this.invoice = 1
      this.getBillMoney()
      if (this.returnSaleMoney(this.billForm.menu) >= 1000 || this.form.invoiceForm === 1 || this.invoice === 1) {
        this.billForm.express = 0
      } else if (this.returnSaleMoney(this.billForm.menu) < 200) {
        this.billForm.express = 0
      } else {
        this.billForm.express = this.invoiceData.fee || 0
      }
      this.getBillMoney()
      this.getExecRule(choosedPackage.totalNum, choosedPackage.price)
    },
    getInvoiceInfo (data) {
      this.invoiceData = data
      if (this.returnSaleMoney(this.billForm.menu) >= 1000 || this.form.invoiceForm === 1) {
        this.billForm.express = 0
      } else {
        this.billForm.express = data.fee
      }
      this.getBillMoney()
    },
    returnShowSaleOff (name) {
      if (this.saleOff) {
        return this.saleOff
      }

      return name
    },
    returnSaleMoney (money) {
      let saleMoney = money
      saleMoney *= this.num
      if (this.saleOff) {
        if (this.discountType === 1) {
          return saleMoney * this.discountAmount
        }

        return saleMoney - this.discountAmount
      }

      return saleMoney
    },
    getExecRule (totalNum, price) {
      if (totalNum && price) {
        this.exeTotalNum = totalNum
        this.extPrice = price
      }
      const data = {
        commodityNo: this.commodityNo,
        price: (price || this.extPrice) * this.num,
        totalNum: (totalNum || this.exeTotalNum) * this.num,
        productId: this.billingProductId,
        showcaseNo: '',
        agentId: this.$route.query.agentId,
        gid: this.userInfo.gid,
        promoCode: this.couponsNumber,
        channelGid: this.$route.query.ditchID,
      }
      this.$ajax(this.$url.execRule(), data)
        .then(res => {
          if (res.data == null || res.data.discountPrice < 0) {
            // 无优惠信息 重置订单数据
            if (res.data.discountPrice < 0) {
              this.$message.error($t('无法使用大于等于订单金额的优惠券'))
            }
            this.activeNo = null
            this.saleOff = ''
            this.discountType = ''
            this.discountAmount = ''
            this.discountPrice = 0
            this.realCouponsNumber = this.couponsNumber = ''
            this.discounted = 0
            this.isChangeStatus = false
            this.btnLoading = false

            return
          }
          this.realCouponsNumber = this.couponsNumber

          this.btnLoading = false
          this.checkCoupons = false
          // 优惠券
          setTimeout(() => {
            this.isChangeStatus = this.realCouponsNumber !== ''
          }, 500)
          this.activeNo = res.data.activeNo
          if (res.data.discountType === 0) {
            this.saleOff = $t('优惠{slot1}元', { slot1: res.data.discountAmount })
          } else if (res.data.discountType === 1) {
            this.saleOff = $t('打{slot1}折', { slot1: numberCal.mul(res.data.discountAmount, 10) })
          }
          this.discountPrice = res.data.discountPrice
          this.discountType = res.data.discountType
          this.discountAmount = res.data.discountAmount
          this.discounted = res.data.discounted
        })
        .catch(() => {
          this.activeNo = null
          this.saleOff = ''
          this.discountType = ''
          this.discountAmount = ''
          this.discountPrice = 0
          this.realCouponsNumber = this.couponsNumber = ''
          this.discounted = 0
          this.isChangeStatus = false
          this.btnLoading = false
        })
    },
    // 获取开票配置类型
    getInvoiceType (companyCode) {
      if (companyCode) {
        this.$ajax(this.$url.getInvoiceType(), { companyCode }).then(res => {
          this.invoiceType.normalInvoiceForm = res.data.normalInvoiceForm
          this.invoiceType.specialInvoiceForm = res.data.specialInvoiceForm
          this.form.invoiceForm = res.data.normalInvoiceForm === 'PAPER' ? 2 : 1
        })
      }
    },
    needInvoice () {
      this.form.invoiceType = 1
      this.getInvoiceType(this.companyCode)
      if (this.returnSaleMoney(this.billForm.menu) >= 1000 || this.form.invoiceForm === 1 || this.invoice === 1) {
        this.billForm.express = 0
      } else {
        this.billForm.express = this.invoiceData.fee || 0
      }
      this.getBillMoney()
    },
    changeInvoice (val) {
      if (val === 2) {
        if (this.returnSaleMoney(this.billForm.menu) < 500) {
          this.$message.error($t('暂不支持500元以下开具增值税专用发票，如需帮助可拨打客服热线：400-087-8198'))
          this.form.invoiceType = 1

          return
        }
        this.form.invoiceForm = this.invoiceType.specialInvoiceForm === 'ELECTRON' ? 1 : 2
      } else {
        this.form.invoiceForm = this.invoiceType.normalInvoiceForm === 'ELECTRON' ? 1 : 2
      }
    },
    handleInput (e) {
      this.count = e.replace(/[^\d]/g, '')
      if (this.count < 500) {
        this.form.invoiceType = 1
      }
    },
    getBillMoney () {
      this.billForm.menu = this.menuData.reduce((item, cur) => item + cur.totalPrice, 0)
      if (this.invoice === 1 || this.billForm.menu >= 1000) {
        this.billForm.total = this.billForm.menu
      } else {
        this.billForm.total = this.billForm.menu + this.billForm.express
      }
    },
    // eslint-disable-next-line complexity
    getParams () {
      let invoice = {}
      if (this.invoice === 1) {
        invoice = {
          /* i18n-ignore */
          type: '线上', //  线下
          invoiceTitleName: null, //  发票抬头
          invoiceType: null, //  发票类型:  1-增值税普通发票;  2-增值税专用发票
          invoiceForm: null, //  开票形式:  1-电子;  2-纸质
          fee: null, //  邮费
          identifyNumber: null, //  纳税人识别号
          bank: null, //  开户银行
          bankAccount: null, //  银行账号
          invoiceAddress: null, //  开票地址
          invoiceTelephone: null, //  开票电话
          email: null, //  接收邮箱
          invoiceRemark: null, //  开票备注
          receiver: null, //  收件人
          receiveAddress: null, //  收件地址
          receivePhone: null, //  收件电话
          expressPayMethod: null, //  快递支付方式:  1-寄付;  2-到付
        }
      } else {


        const getInvoiceInfo = () => {
          const { invoiceForm } = this.form
          const defaultValues = { receiver: '', receiveAddress: '', receivePhone: '' }

          if (invoiceForm === 1 || !this.invoiceData?.address) {
            return defaultValues
          }

          const { contact, addressAll, contactNumber } = this.invoiceData.address

          return {
            receiver: contact || '',
            receiveAddress: addressAll || '',
            receivePhone: contactNumber || '',
          }
        }

        const { receiver, receiveAddress, receivePhone } = getInvoiceInfo()

        invoice = {
          /* i18n-ignore */
          type: '线上', //  线下
          invoiceTitleName: this.userInfo.name || null, //  发票抬头
          invoiceType: +this.form.invoiceType, //  发票类型:  1-增值税普通发票;  2-增值税专用发票
          invoiceForm: this.form.invoiceForm, //  开票形式:  1-电子;  2-纸质
          fee: this.billForm.express, //  邮费
          identifyNumber: this.form.identifyNumber || null, //  纳税人识别号
          bank: this.form.bank || null, //  开户银行
          bankAccount: this.form.bankAccount || null, //  银行账号
          invoiceAddress: this.form.invoiceAddress || null, //  开票地址
          invoiceTelephone: this.form.invoiceTelephone || null, //  开票电话
          email: this.form.invoiceEmail || null, //  接收邮箱
          invoiceRemark: null, //  开票备注
          receiver,
          receiveAddress,
          receivePhone,
          expressPayMethod: +this.invoiceData.expressType, //  快递支付方式:  1-寄付;  2-到付
        }
      }
      invoice.customerName = this.userInfo.name
      invoice.customerType = this.isOrg ? 1 : 0
      // 组装参数
      let commodities = []
      if (this.menuData[0].saleType === 1 || this.menuData[0].saleType === 3) {
        commodities = this.menuData.map(item => ({
          commodityId: item.id, //  商品ID
          num: this.num,
          specification: {
            //  规格
            id: item.menu, //  充值或套餐的ID
            idType: this.saleType === 1 ? 'plan' : 'license', //  rule或plan
            realVolumn: this.packages.filter(x => x.id === item.menu)[0].totalNum, //  套餐数量
            isContinuedValidityTerm: this.isContinuedValidityTerm === 1
          }
        }))
      } else {
        commodities = this.menuData.map(item => ({
          commodityId: item.id, //  商品ID
          specification: {
            //  规格
            id: item.billingRules[0].id, //  充值或套餐的ID
            idType: 'rule', //  rule或plan
            realAmount: this.billForm.menu, //  套餐数量
            isContinuedValidityTerm: this.isContinuedValidityTerm === 1
          }
        }))
      }
      const params = {
        commodities,
        businessId: this.$route.query.businessId,
        _latest_tsign_source_type: this.$route.query.tsign_source_type || this.tsignData._latest_tsign_source_type,
        _latest_tsign_source_detail:
          this.$route.query.tsign_source_detail || this.tsignData._latest_tsign_source_detail,
        platformType: 'WEB',
        accountingInfo: {
          totalAmount: this.billForm.menu //  下单总额
        },
        validDateTime: this.useTime, //  订单生效时间
        invoice: {
          //  发票项
          ...invoice
        },
        addressInfo: this.addressInfo,
        activeNo: this.activeNo,
        needInvoice: this.invoice !== 1, //  是否需要发票
        sourceChannel: this.sourceChannel,
        settleContext: {
          cooperatorId: this.$route.query.cooperatorId || '',
          cooperatorMode: this.$route.query.cooperatorMode || '',
          projectCode: this.$route.query.projectCode || ''
        }
      }

      return params
    },

    async payment () {
      // 获取订单号（乐胥）
      if (!this.paying && this.checked) {
        this.paying = true
        let orderList = [] // 乐胥返回订单号
        let invoiceNum = ''
        const data = this.getParams()
        data.clientChannel = 0
        data.licenseId = this.$route.query.licenseId
        data.agentId = this.$route.query.agentId
        data.channelGid = this.$route.query.ditchID

        await this.$ajax(this.$url.getBillIds(), data).then(res => {
          orderList = res.data.orderIds
          // eslint-disable-next-line prefer-destructuring
          invoiceNum = res.data.invoiceNum
        })
        if (orderList === null) {
          this.$message.error($t('生成订单失败'))

          return
        }
        this.$reportBusiness('business_monitor_event_start', 'order_pay', {
          appId: this.$route.query.appid,
          ouid: this.userInfo.gid,
          orgId: this.userInfo.orgId,
          orderId: orderList[0],
          stage: 'OrderConfirm'
        })
        if (this.invoice === 2) {
          this.$router.replace({
            path: '/RechargeOnline',
            query: {
              orderId: orderList[0],
              fee: this.billForm.express,
              invoiceId: invoiceNum,
              invoiceOnline: 1,
              isDeliver: this.isDeliver
            }
          })
        } else {
          this.$router.replace({
            path: '/RechargeOnline',
            query: {
              orderId: orderList[0],
              fee: this.billForm.express,
              isDeliver: this.isDeliver
            }
          })
        }
      }
    },
    async createOrder () {
      if (!this.checked) {
        return false
      }
      if (this.invoice === 2 && this.returnSaleMoney(this.billForm.menu) >= 2000000 && this.form.invoiceType === 1) {
        return this.$message.error($t('抱歉，单次发票可开具金额为1999999.99，请联系客服获取发票。'))
      }
      if (!this.addressInfo.receiverAddress && this.isDeliver) {
        return this.$message.error($t('请选择收货地址'))
      }
      this.userInfo.orgId && (await this.$ajax(this.$url.space(this.userInfo.orgId)))
      this.pay()
    },
    // eslint-disable-next-line complexity
    async pay () {
      if (!this.useTime && this.isContinuedValidityTerm === 2) {
        this.$message.error($t('请选择订单生效时间'))

        return
      }

      if (
        !(this.invoiceData.address && this.invoiceData.address.contact) &&
        this.invoice === 2 &&
        this.form.invoiceForm === 2
      ) {
        this.$message.error($t('请选择收货地址'))

        return
      }
      const data = {
        commodityNo: this.commodityNo,
        price: this.extPrice * this.num,
        totalNum: this.exeTotalNum * this.num,
        productId: this.billingProductId,
        agentId: this.$route.query.agentId,
        gid: this.userInfo.gid,
        promoCode: this.realCouponsNumber,
        channelGid: this.$route.query.ditchID,
      }
      const res = await this.$ajax(this.$url.execRule(), data)
      if ((res.data == null && this.activeNo == null) || (res.data && res.data.activeNo === this.activeNo)) {
        console.log()
      } else {
        this.$alert($t('产品价格发生变更，请点击确定，页面将自动刷新！'), $t('提示'), {
          confirmButtonText: $t('确定'),
          callback: () => {
            this.$router.go(0)
          }
        })

        return
      }
      const regexp = /^((?:(?:(\+)|(00))86)?1\d{10})$|^([48]00-?\d{3}-?\d{4})$|^((?:0\d{2,3}-)?(\d{5,8}(-\d{3,5})?))$/
      const regexp1 = /^([a-zA-Z0-9]{15}|[a-zA-Z0-9]{18}|[a-zA-Z0-9]{20}|)$/
      const regEx = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      // 普通发票提交时的前端校验，开户银行+银行账户
      if ((this.form.bank === '' && this.form.bankAccount) || (this.form.bank && this.form.bankAccount === '')) {
        this.$message.error(
          $t('开票银行名称和开票银行账户需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息')
        )

        return false
      }
      // 开票地址+开票电话
      if (
        (this.form.invoiceAddress === '' && this.form.invoiceTelephone) ||
        (this.form.invoiceAddress && this.form.invoiceTelephone === '')
      ) {
        this.$message.error($t('开票地址和开票电话需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息'))

        return false
      } else if (this.form.invoiceTelephone && !regexp.test(this.form.invoiceTelephone)) {
        this.$message.error($t('请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888'))

        return false
      } else if (this.form.identifyNumber && !regexp1.test(this.form.identifyNumber)) {
        this.$message.error($t('纳税人识别号请输入15或18位数字或字母的组合'))

        return false
      }
      // 接收邮箱
      if (this.form.invoiceType === 2 && this.form.invoiceForm === 1) {
        if (this.form.invoiceEmail && !regEx.test(this.form.invoiceEmail)) {
          this.$message.error($t('请正确填写接收邮箱'))

          return false
        }
      }
      // 不开发票或者普通发票不需要强校验
      if (this.form.invoiceType === 1 || this.invoice === 1) {
        // 不开发票或者个人开票不校验纳税人识别号
        this.payment()
      } else {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.payment()
          }
        })
      }
    }
  },
  watch: {
    form: {
      handler (value) {
        if (value.invoiceForm === 2) {
          this.showAddress = true
          if (this.returnSaleMoney(this.billForm.menu) >= 1000) {
            this.billForm.express = 0
            this.billForm.total = this.billForm.menu
          } else {
            this.billForm.express = this.invoiceData.fee || 0
            this.billForm.total = this.billForm.menu + this.billForm.express
          }
        } else {
          this.billForm.express = 0
          this.billForm.total = this.billForm.menu
          this.showAddress = false
        }
      },
      deep: true
    },
    count: {
      handler (newVal) {
        this.invoice = 1
        this.billForm.express = 0
        if (newVal) {
          this.menuData[0].standardPrice = parseFloat(newVal)
          this.menuData[0].totalPrice = parseFloat(newVal)
          this.getBillMoney()
        } else {
          this.menuData[0].standardPrice = 0
          this.menuData[0].totalPrice = 0
          this.getBillMoney()
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    // eslint-disable-next-line no-prototype-builtins
    if (to.query.hasOwnProperty('operating')) {
      const query = JSON.parse(base64Decode(to.query.operating))
      Object.keys(query).forEach(item => {
        to.query[item] = query[item]
      })
    }
    next()
  }
}
</script>
<style lang="less" scoped>
.body {
  padding: 30px 24px;
}

.es-input-number {
  width: 100px;
}

.confirm {
  width: 100%;
  position: relative;
  display: flex;

  &-time {
    height: 30px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 20px;
  }

  &-table {
    margin-bottom: 10px;
    width: 100%;
  }

  &-pdf {
    height: 260px;
    overflow: auto;
    margin-bottom: 10px;
    border: 1px solid #f3f3f3;
  }

  &-agree {
    line-height: 20px;
    margin-bottom: 37px;

    &-btn {
      font-size: 14px;
      color: #1875f0;
      cursor: pointer;
    }

    /deep/ .es-checkbox {
      margin-right: 10px;
    }
  }

  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7px;

    &-text {
      color: #333333;
      font-size: 16px;
      line-height: 28px;
    }
  }

  &-bill {
    margin: 60px 0 96px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &-form {
      margin-bottom: 18px;

      &-item {
        text-align: right;
        margin-bottom: 6px;
      }
    }

    &-confirm {
      width: 160px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      background: #0975e0ff;
      cursor: pointer;
    }
  }
}

.infoBody {
  .ruleForm {
    display: flex;
    width: 100%;

    div.left,
    div.right {
      flex: 1;

      >div {
        height: 30px;
        line-height: 30px;
        display: flex;
        margin-bottom: 20px;
      }

      .inline-block {
        >div {
          height: 30px;
          line-height: 30px;
          margin-bottom: 0px;
          flex: 1;
        }
      }
    }
  }
}

.content {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
}

.container {
  width: 100%;

  .confirm-agree {
    display: flex;
    align-items: center;
  }
}

.protocol {
  height: 500px;
  margin-bottom: 30px;
  overflow: auto;
}

.disabled {
  background-color: #84baf0ff;
  cursor: not-allowed;
}

.el-icon-circle-plus {
  vertical-align: middle;
  cursor: pointer;
  color: rgb(17, 170, 102);
  font-size: 18px;
}

.content {
  display: flex;
  align-items: center;

  .content-left {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    margin-right: 10px;

    i {
      font-size: 42px;
    }
  }

  .content-right {
    flex: 1;
  }
}

.change-ticket {
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #0975e0;

  i {
    color: #0975e0;
  }

  .el-icon-remove {
    margin-left: 5px;
  }
}

.tips {
  text-align: center;
  color: red;
}

.text-center {
  text-align: center;
}

.gift-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url('../../assets/common/gift.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
  vertical-align: text-top;
}

/deep/ .es-empty__image {
  width: 64px;
}
</style>
